module.exports = "pegasus/assets/pets-logo.png";